import { FC } from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer } from 'recharts';

interface AverageGradeChartProps {
  avgGrade: number;
  gradeImprovement: number;
  size?: 'small' | 'large';
}

const GRADE_COLORS = ['#2B3440', '#E5E7EB'];

const AverageGradeChart: FC<AverageGradeChartProps> = ({ avgGrade, gradeImprovement, size = 'large' }) => {
  const data = [
    { name: 'current', value: avgGrade },
    { name: 'remaining', value: 9 - avgGrade },
  ];

  const chartConfig = {
    small: {
      height: 85,
      innerRadius: 40,
      outerRadius: 60,
      fontSize: 'text-xl',
      padding: 'p-2',
      marginBottom: 'mb-1',
      marginTop: 'mt-2',
    },
    large: {
      height: 100,
      innerRadius: 50,
      outerRadius: 70,
      fontSize: 'text-2xl',
      padding: 'p-3',
      marginBottom: 'mb-2',
      marginTop: 'mt-2',
    },
  };

  const config = chartConfig[size];

  return (
    <div
      className={`bg-white rounded-[20px] border border-[#CCCCCC] border-opacity-50 ${config.padding} flex flex-col items-center justify-center ${size === 'large' ? 'min-w-[280px]' : 'w-full max-w-[400px]'}`}
    >
      <h3 className={`text-sm font-medium ${config.marginBottom}`}>Avg. Grade</h3>
      <div className="w-full" style={{ height: config.height }}>
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Pie
              data={data}
              cx="50%"
              cy="100%"
              innerRadius={config.innerRadius}
              outerRadius={config.outerRadius}
              startAngle={180}
              endAngle={0}
              dataKey="value"
            >
              {data.map((_, index) => (
                <Cell key={`cell-${index}`} fill={GRADE_COLORS[index]} />
              ))}
            </Pie>
          </PieChart>
        </ResponsiveContainer>
      </div>
      <div className="text-center mt-2">
        <p className={`${config.fontSize} font-bold text-[#2B3440]`}>{avgGrade}</p>
        {gradeImprovement !== 0 && (
          <>
            <p className={`text-xs ${gradeImprovement > 0 ? 'text-green-500' : 'text-red-500'}`}>
              {gradeImprovement > 0 ? '+' : ''}
              {gradeImprovement}
            </p>
            <p className="text-[10px] text-gray-500">
              {gradeImprovement > 0 ? 'Your performance is improving!' : 'Keep practicing to improve!'}
            </p>
          </>
        )}
      </div>
    </div>
  );
};

export default AverageGradeChart;
